import React, { useEffect, useState, useCallback } from 'react';
import { Amplify } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'bootstrap/dist/css/bootstrap.min.css';

import "../../src/styles/header.css";

import BRAND_LOGO from '../images/home-logo.png';

import { fetchUser } from '../redux/actions/fetchUser';

import awsconfig from '../aws-exports';

Amplify.configure(awsconfig);

const MyNavbar = ({ isSmallScreen }) => {
    const [user, setUser] = useState(localStorage.getItem('email'));

    const [showLogout, setShowLogout] = useState(false);
    

    
    const userFirstLetter = user?.charAt(0)?.toUpperCase();
  
    const navigate = useNavigate();
    const dispatch = useDispatch();


    // Logout modal
  const handleCloseLogout = () => {
    setShowLogout(false);    
  } 

  const handleShowLogout = () => {   
    setShowLogout(true);    
  }

    const logout = useCallback(() => { 
      setShowLogout(false);
      localStorage.clear();
      navigate('/');  
      setUser('');
      
    }, [navigate]);

  useEffect(() => {
    setUser(localStorage.getItem('email'));

  }, [navigate]);

  useEffect(() => {
    dispatch(fetchUser(user));
  }, [user, dispatch]);
  

  return (
    <div className='nav-container'>
      <ul className='header-ul'>
        { isSmallScreen &&
          <div style={{ width: '100%' }}>
            <img  src={BRAND_LOGO} alt='' className='nav-container-img'/>
        </div>
        }
        {user ? (
          <>          
            <li key="avatar" style={{ marginTop: '1%', marginRight: '1rem' }}>                                              
              <button className='avatar' onClick={() => handleShowLogout()}>{userFirstLetter}</button>
            </li>
          </>
        ):
        <li>
          <a href='/#auth/signin' className='login-link'>Login</a>
        </li>        
        }
      </ul> 
    
    

       {/* modal to view Logout modal*/}

      <Modal size='sm' className='logout-modal' show={showLogout} onHide={handleCloseLogout}>
          <Modal.Header  className='modal-color-header'>           
            <Modal.Title className='header-modal-title-container' >
              <div>{user}</div>
              <button className="custom-close" onClick={handleCloseLogout}>X</button>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className='modal-color'>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <div className='avatar-modal'>{userFirstLetter}</div> 
            </div>

              <div style={{ display: 'flex', justifyContent: 'center'}}>
                <button
                  className='signout-btn'            
                  variant='text'
                  onClick={logout} >
                    <span>
                      <FontAwesomeIcon icon="fa-solid fa-arrow-right-from-bracket" />
                    </span>
                    {' '}
                    <span className='signout-btn-text'>Sign out</span>
                </button>
              </div>            
          </Modal.Body>
        </Modal>
    </div>
    
        
  );
};

export default MyNavbar;
